//TODO: REWORK THIS COMPONENT ONCE THE SELECT COMPONENT IS REWORKED

import type { ComponentPropsWithoutRef } from 'react';

import type { SocialProfileType } from '@/types/socialProfileType';

import type { OptionType } from '@/components/base/Select';
import Select from '@/components/base/Select';
import type { SocialProfileInfoProps } from '@/components/composite/SocialProfiles/Components/SocialProfileInfo';
//Components
import { SocialProfileInfo } from '@/components/composite/SocialProfiles/Components/SocialProfileInfo';

type SelectButtonProps = {
    error?: string;
    disabled?: boolean;
    selected?: OptionType;
    baseStyle?: ComponentPropsWithoutRef<typeof Select.Button>['baseStyle'];
    sizeStyle?: ComponentPropsWithoutRef<typeof Select.Button>['sizeStyle'];
    forcedDisplay?: boolean;
};
function SelectButton({ error, disabled, selected, sizeStyle, baseStyle }: SelectButtonProps) {
    return (
        <Select.Button
            selected={selected}
            disabled={disabled}
            error={error}
            baseStyle={baseStyle}
            sizeStyle={sizeStyle}>
            <SocialProfilePreview profile={selected as SocialProfileType} />
        </Select.Button>
    );
}

export function SocialProfilePreview(props: SocialProfileInfoProps) {
    return (
        <div className="flex items-center gap-3 overflow-hidden py-0.5">
            <SocialProfileInfo {...props} />
        </div>
    );
}

type OptionProps = { option?: OptionType };
function Option({ option }: OptionProps) {
    return <SocialProfilePreview profile={option as SocialProfileType} size="md" />;
}

type SelectSocialProfileProps = {
    socialProfilesList: SocialProfileType[];
    selected: SocialProfileType;
    setSelected: (selected: SocialProfileType) => void;
    selectButtonBaseStyle?: ComponentPropsWithoutRef<typeof Select.Button>['baseStyle'];
};
export function SelectSocialProfile({
    socialProfilesList,
    selected,
    setSelected,
    selectButtonBaseStyle = 'noBorder'
}: SelectSocialProfileProps) {
    return (
        <Select
            setSelected={(selectedSocialProfile) =>
                setSelected(selectedSocialProfile as SocialProfileType)
            }
            noBorder
            selected={selected as OptionType}
            options={socialProfilesList as OptionType[]}
            button={<SelectButton baseStyle={selectButtonBaseStyle} />}>
            <Option />
        </Select>
    );
}
